import { render, staticRenderFns } from "./media-uploader.vue?vue&type=template&id=54f5774e&scoped=true"
import script from "./media-uploader.ts?vue&type=script&lang=ts&external"
export * from "./media-uploader.ts?vue&type=script&lang=ts&external"
import style0 from "./media-uploader.less?vue&type=style&index=0&id=54f5774e&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f5774e",
  null
  
)

export default component.exports